"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const LoginForm_1 = __importDefault(require("./LoginForm"));
function ChangeEmailError(props) {
    return (react_1.default.createElement(LoginForm_1.default, { onSubmit: () => { }, title: "Change Email Address", footer: (react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-xs-12 text-center" },
                react_1.default.createElement("a", { className: "login-link", onClick: () => props.onCancel() }, "Back to Login")))) },
        react_1.default.createElement("div", null,
            react_1.default.createElement("p", null, "Your email address couldn't be updated."),
            react_1.default.createElement("p", null, "It might have been too long since you requested the change, or the email address might no longer be available."))));
}
exports.default = ChangeEmailError;
